import { OktaAuth, scopes } from './'
const loginWithRedirect = () => {
  window.sessionStorage.removeItem('user')
  OktaAuth.token.getWithRedirect(scopes)
}

export default loginWithRedirect
